import script from "./workflowEditor.vue?vue&type=script&lang=js"
export * from "./workflowEditor.vue?vue&type=script&lang=js"

import "./workflowEditor.vue?vue&type=style&index=0&id=40959b0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40959b0c"]])

export default __exports__